import './globals.js';
import onPostMessage from './events/onPostMessage.js';
import onAuthflowCookiesWillSet from './events/onAuthflowCookiesWillSet.js';
import onAuthflowCookiesDidSet from './events/onAuthflowCookiesDidSet.js';
import onCheckoutAbandoned from './events/onCheckoutAbandoned.js';
import onCheckoutAuthenticating from './events/onCheckoutAuthenticating.js';
import onCheckoutComplete from './events/onCheckoutComplete.js';
import onCheckoutNotStarted from './events/onCheckoutNotStarted.js';
import onCheckoutPaying from './events/onCheckoutPaying.js';
import onBedrockAccountCreate from './events/onBedrockAccountCreate.js';
import onBedrockSignInUser from './events/onBedrockSignInUser.js';
import onBedrockSignOutUser from './events/onBedrockSignOutUser.js';

// TODO: Pull out window.addEventListener from these files
// and switch to regular imports. Do all event listener wiring in integration.js
// similar to onPostMessage, etc.
import './events/onZephrAnalyticsRuleOutcomeConversion.js';
import './events/onZephrOutcomeHistoryAppend.js';
import './events/onZephrClose.js';
import './events/onZephrInitializeComponent.js';
import './events/onZephrObserveDelayedTrigger.js';
import './events/onZephrObserveExitTrigger.js';
import './events/onZephrObserveExitTriggerMouse.js';
import './events/onZephrObserveExitTriggerScroll.js';
import './events/onZephrResize.js';
import './events/onZephrShowComponent.js';
import './events/onZephrUnmountAllOutcomes.js';
import './events/onZephrHistoryReplace.js';

window.addEventListener('message', onPostMessage);

window.addEventListener('onauthflowcookiesdidset', onAuthflowCookiesDidSet);
window.addEventListener('onauthflowcookieswillset', onAuthflowCookiesWillSet);

window.addEventListener('onbedrockaccountcreate', onBedrockAccountCreate);
window.addEventListener('onbedrocksigninuser', onBedrockSignInUser);
window.addEventListener('onbedrocksignoutuser', onBedrockSignOutUser);

window.addEventListener('oncheckoutabandoned', onCheckoutAbandoned);
window.addEventListener('oncheckoutauthenticating', onCheckoutAuthenticating);
window.addEventListener('oncheckoutcomplete', onCheckoutComplete);
window.addEventListener('oncheckoutnotstarted', onCheckoutNotStarted);
window.addEventListener('oncheckoutpaying', onCheckoutPaying);
